<template>
    <div class="knd-buy-credits knd-pb-10">
        <div class="knd-wrapper">
            <h3>credits</h3>
            <img class="knd-credits_img knd-mb-10" src="@/assets/icons/icon_credits.svg" />

            <div class="credit_items knd-flex knd-justify-evenly">
                <div 
                    class="credit_item" 
                    :class="{active: selectedIndex === index}"
                    v-for="(option, index) in options" :key="'credits-' + index"
                    @click="clicked(index)"
                >
                    <div class="credit_item__inner">
                        <div class="credit_item_credits">
                            <h5 class="">{{option.credits}}</h5>
                            <h5>credits</h5>
                        </div>

                        <div class="credit_item_btn knd-bg-red knd-p-3 knd-rounded-md knd-text-white">
                            <div>€{{option.prijs}}</div>
                            <div class="knd-text-base">€{{option.credit}} per credit</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    let options = [
        {
            credits: 8,
            prijs: '10',
            credit: '1,25'
        },
        {
            credits: 25,
            prijs: '27,50',
            credit: '1,10'
        },
        {
            credits: 45,
            prijs: '47,50',
            credit: '1,05'
        },                
    ]

    export default {
        data() {
            return {
                bought: false,
                credits: undefined,
                selectedIndex: undefined,
                multiply: 50,
                options
            }
        },
        methods: {
            clicked(index) {
                if(this.selectedIndex !== undefined) return;
                this.selectedIndex = index;

                this.credits = options[index].credits;
                this.bought = true;

                this.$store.dispatch('creditsAdd', this.credits);
            }
        },
    }
</script>

<style lang="scss" scoped>
    .knd-buy-credits {
        min-height: 50vh;
        background: #EFFFE2;

        h5 {
            margin-bottom: 0;
        }
    }

    .knd-credits_img {
        margin-left: auto;
        margin-right: auto;
        width: 75px;
    }

    .credit_item {
        background: theme('colors.jade.light');
         border-radius: 10px;
         cursor: pointer;
         margin-bottom: 1rem;

         transition: background .2s ease-in;
         flex-direction: column;

         @screen md {
            flex-direction: row;
         }

        &:hover, &.active {
            background: theme('colors.jade.DEFAULT');

             .credit_item__inner {
                border: 1px solid theme('colors.green.light');
                color: theme('colors.jade.light');
             }

             .credit_item_btn {
                background: theme('colors.jade.light');
                color: theme('colors.jade.DEFAULT');
             }
        }
    }

    .credit_item_btn { 
        transition: background .2s ease-in;
        flex: 1;
    }

    .credit_items {
        flex-direction: column;
        @screen md {
            flex-direction: row;
         }  
    }

    .credit_item_credits {
        flex: 0 0 100px;
    }

    .credit_item__inner {
        pointer-events: none;
        margin: 1rem;
        padding: 1rem;
        color: theme('colors.red.DEFAULT');
        border: 1px solid theme('colors.red.light');
        border-radius: 10px;
        margin: 1em;
        text-align: center;
        display: flex;
        align-items: center;

        @screen md {
            flex-direction: column;
         }        
    }    
</style>